const STORAGE_KEY = 'pixelutility-size-history';
const MAX_ITEMS = 6;

export function loadRecentHistory() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function saveRecentHistory(entry) {
  if (!entry?.sizeValue) return;
  try {
    const list = loadRecentHistory().filter(
      (item) =>
        !(
          item.categoryId === entry.categoryId &&
          item.gender === entry.gender &&
          item.systemId === entry.systemId &&
          item.sizeValue === entry.sizeValue
        )
    );
    list.unshift({ ...entry, savedAt: Date.now() });
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_ITEMS)));
  } catch {
    /* storage full or disabled */
  }
}

export function clearRecentHistory() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
